import React, { useState, useEffect } from "react";
import Header from "../Common/Header";
import Sidebar from "../Common/Sidebar";
import Footer from "../Common/Footer";
import axios from "axios";
import Swal from "sweetalert2";


export default function DepositWithdrawal() {
    const [packages, setPackages] = useState([]);
    const [txUserId, setTxUserId] = useState("");
    const [balance, setBalance] = useState(0);
    const [actionLoading, setActionLoading] = useState(false);

    const [Tbalance, setTBalance] = useState(0);
    const [selectedPackage, setSelectedPackage] = useState(null);
    const [quantity, setQuantity] = useState(1);
    const [loading, setLoading] = useState(false);
    const [loadingBalance, setLoadingBalance] = useState(false);

    const [actionType, setActionType] = useState(""); // transfer | withdrawal
    
    const [amount, setAmount] = useState("");

    const generate3LetterHash = () => {
        const chars = "abcdefghijklmnopqrstuvwxyz0123456789";
        let result = "";
        for (let i = 0; i < 3; i++) {
            result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return result;
    };

    // Fetch packages
    const getPackages = async () => {
        try {
            const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                method: "package",
                submethod: "get",
                key: process.env.REACT_APP_KEY,
            });

            if (res.data?.resCode === 200) {
                setPackages(res.data.data || []);
            }
        } catch (err) {
            console.error("Package fetch error", err);
        }
    };

    useEffect(() => {
        getPackages();
    }, []);

    const payableAmount = selectedPackage
        ? selectedPackage.amount * quantity
        : 0;

    const handlePurchase = async () => {
        console.log('txUserId', selectedPackage);

        if (!selectedPackage) {
            Swal.fire("Error", "Select a package first", "error");
            return;
        }
        if (quantity <= 0) {
            Swal.fire("Error", "Enter a valid quantity", "error");
            return;
        }
        if (!txUserId) {
            Swal.fire("Error", "Enter User ID", "error");
            return;
        }

        try {
            setLoading(true);

            const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                method: "transaction",
                submethod: "insert",
                key: process.env.REACT_APP_KEY,
                username: txUserId,
                amount: selectedPackage.amount,
                value: quantity,
            });

            // console.log('selectedPackage.value', selectedPackage.value);

            // console.log('res.data', res.data);

            if (res.data?.resCode === 200) {
                Swal.fire("Success", "Package Purchased Successfully", "success");
                setTxUserId("");
                setSelectedPackage(null);
                setQuantity(1);
                setTBalance(0);
                setBalance(0);
            } else {
                Swal.fire("Error", res.data?.error || "Failed", "error");
            }
            setLoading(false);
        } catch (err) {
            setLoading(false);
            Swal.fire("Error", "Server Error", "error");
        }
    };

    const fetchBalance = async () => {
        if (!txUserId) {
            Swal.fire("Error", "Enter User ID", "error");
            return;
        }

        try {
            setLoadingBalance(true);

            const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                method: "user",
                submethod: "ubalance",
                username: txUserId,
                key: process.env.REACT_APP_KEY,
            });
            console.log('res.data.balance', res.data.data.balance);

            if (res.data?.resCode === 200) {
                setTBalance(res.data.data.deposit)
                setBalance(res.data.data.balance);
            } else {
                Swal.fire("Error", res.data?.message || "User not found", "error");
            }
        } catch {
            Swal.fire("Error", "Server error", "error");
        } finally {
            setLoadingBalance(false);
        }
    };

    const submitAction = async () => {
        if (!amount) {
            Swal.fire("Error", "Enter amount", "error");
            return;
        }

        try {
            setActionLoading(true);

            if (actionType === "transfer") {
                const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                    method: "transfer",
                    submethod: "insert",
                    username: "1169158525",
                    amount,
                    tusername: txUserId,
                    key: process.env.REACT_APP_KEY,
                });

                if (res.data?.resCode === 200) {
                    Swal.fire("Success", res.data.msg, "success");
                    fetchBalance();
                    setAmount("");
                    setTxUserId("");
                    setTBalance(0);
                    setBalance(0);
                } else {
                    Swal.fire("Error", res.data?.error, "error");
                }
            }

            if (actionType === "deposit") {
                const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                    method: "admin",
                    submethod: "admindeposit",
                    username: txUserId,
                    deposit: amount,
                    key: process.env.REACT_APP_KEY,
                });

                if (res.data?.resCode === 200) {
                    Swal.fire("Success", res.data.msg, "success");
                    fetchBalance();
                    setAmount("");
                    setTxUserId("");
                    setTBalance(0);
                    setBalance(0);
                } else {
                    Swal.fire("Error", res.data?.error, "error");
                }
            }

            if (actionType === "mwithdrawal") {
                const hash = generate3LetterHash(); // e.g. ABC
                const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                    method: "withdrawal",
                    submethod: "manual",
                    username: txUserId,
                  
                    amount,
                    hash,
                    key: process.env.REACT_APP_KEY,
                });

                if (res.data?.resCode === 200) {
                    Swal.fire("Success", res.data.msg, "success");
                    fetchBalance();
                    setAmount("");
                    setTxUserId("");
                   
                    setTBalance(0);
                    setBalance(0);
                } else {
                    Swal.fire("Error", res.data?.error, "error");
                }
            }
        } catch (err) {
            Swal.fire("Error", "Action failed", "error");
        } finally {
            setActionLoading(false);
        }
    };

    useEffect(() => {
        if (!txUserId || txUserId.trim() === "") {
            setBalance(0);
            setTBalance(0);
        }
    }, [txUserId]);


    return (
        <>
            <Header />
            <Sidebar />
            <div className="buy-package-container">
                <h2 className="buy-title">Admin Operations</h2>

                {/* USER ID */}
                <div className="input-group" style={{ display: "flex", justifyContent: "center" }}>
                    <input
                        type="text"
                        placeholder="Enter User ID"
                        value={txUserId}
                        onChange={(e) => setTxUserId(e.target.value)}
                    />
                </div>

                <button className="action-btn" onClick={fetchBalance}>
                    {loadingBalance ? "Checking..." : "Show Balance"}
                </button>

                {balance !== null && Tbalance !== null && (
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            gap: "40px",
                            marginTop: "15px",
                            flexWrap: "wrap"
                        }}
                    >
                        <h3
                            className="balance-text text-black"
                            style={{ margin: 0, fontSize: "18px" }}
                        >
                            Withdrawal Balance: ${Number(balance).toFixed(2)}
                        </h3>

                        <h3
                            className="balance-text text-black"
                            style={{ margin: 0, fontSize: "18px" }}
                        >
                            Staking Balance: ${Number(Tbalance).toFixed(2)}
                        </h3>
                    </div>
                )}



                <div className="action-section">
                    <div className="option-buttons">
                        <button
                            className={actionType === "transfer" ? "active" : ""}
                            onClick={() => setActionType("transfer")}
                        >
                            Transfer
                        </button>
                        <button
                            className={actionType === "deposit" ? "active" : ""}
                            onClick={() => setActionType("deposit")}
                        >
                            Deposit
                        </button>
                        <button
                            className={actionType === "stake" ? "active" : ""}
                            onClick={() => setActionType("stake")}
                        >
                            Staking
                        </button>
                        <button
                            className={actionType === "mwithdrawal" ? "active" : ""}
                            onClick={() => setActionType("mwithdrawal")}
                        >
                            Manual Withdrawal
                        </button>
                    </div>

                    {/* stake FORM */}
                    {actionType === "stake" && (
                        <div className="buy-package-container">
                            <h2 className="buy-title">Buy Package</h2>

                            <div className="package-grid">
                                {packages.map((pkg) => (
                                    <div
                                        key={pkg.value}
                                        className={`package-card ${selectedPackage?.value === pkg.value ? "active" : ""
                                            }`}
                                        onClick={() => setSelectedPackage(pkg)}
                                    >
                                        <h4>{pkg.p_name}</h4>
                                        <span className="price text-black">${pkg.amount}</span>
                                    </div>
                                ))}
                            </div>

                            <div className="bottom-section">
                                <div className="quantity-group">
                                    <label>Quantity</label>
                                    <input
                                        type="number"
                                        min="1"
                                        value={quantity}
                                        onChange={(e) => setQuantity(Number(e.target.value))}
                                        style={{
                                            width: "80px",
                                            borderRadius: "5px",
                                            padding: "5px",
                                        }}
                                    />
                                </div>

                                <div className="payable-amount">
                                    Payable Amount
                                    <strong>${payableAmount}</strong>
                                </div>
                            </div>


                            <button
                                className="buy-btn"
                                onClick={handlePurchase}
                                disabled={loading}
                            >
                                {loading ? "Please wait 3-5 minutes..." : "Confirm Purchase"}
                            </button>

                        </div>
                    )}

                    {/* TRANSFER FORM */}
                    {actionType === "transfer" && (
                        <div className="form-box">
                            <input
                                placeholder="Enter Username"
                                value={txUserId}
                                disabled // Non-editable
                            // value={targetUser}
                            // onChange={(e) => setTargetUser(e.target.value)}
                            />
                            <input
                                placeholder="Amount"
                                type="number"
                                value={amount}
                                onChange={(e) => setAmount(e.target.value)}
                            />
                            <button
                                className="buy-btn"
                                onClick={submitAction}
                                disabled={actionLoading}
                            >
                                {actionLoading ? "Transferring..." : "Confirm Transfer"}
                            </button>

                        </div>
                    )}

                    {/* deposit FORM */}
                    {actionType === "deposit" && (
                        <div className="form-box">
                            <input
                                placeholder="Enter Username"
                                value={txUserId}
                                disabled
                            // onChange={(e) => setTargetUser(e.target.value)}
                            />
                            <input
                                placeholder="Amount"
                                type="number"
                                value={amount}
                                onChange={(e) => setAmount(e.target.value)}
                            />
                            <button
                                className="buy-btn"
                                onClick={submitAction}
                                disabled={actionLoading}
                            >
                                {actionLoading ? "Processing..." : "Confirm Deposit"}
                            </button>

                        </div>
                    )}
                    {/* mwithdrawal FORM */}
                    {actionType === "mwithdrawal" && (
                        <div className="form-box">
                            <input
                                placeholder="Enter Username"
                                value={txUserId}
                                disabled
                            // onChange={(e) => setTargetUser(e.target.value)}
                            />
                           
                            <input
                                placeholder="Amount"
                                type="number"
                                value={amount}
                                onChange={(e) => setAmount(e.target.value)}
                            />
                            <button
                                className="buy-btn"
                                onClick={submitAction}
                                disabled={actionLoading}
                            >
                                {actionLoading ? "Processing..." : "Confirm Withdrawal"}
                            </button>

                        </div>
                    )}
                </div>


            </div>

            <style>
                {`
                .buy-title {
    font-size: 26px;
    font-weight: 700;
    color: #0d47a1;
    margin-bottom: 30px;
}

.input-group input {
    width: 260px;
    padding: 10px 14px;
    border-radius: 10px;
    border: 1px solid #dcdcdc;
    outline: none;
    font-size: 15px;
}

.package-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 22px;
    margin: 35px 0;
}

.package-card {
    padding: 12px;
    border-radius: 16px;

    color: #ffffff;
    cursor: pointer;
    transition: all 0.3s ease;

}

.package-card h4 {
    margin-bottom: 8px;
    font-size: 18px;
    font-weight: 600;
}

.package-card .price {
    font-size: 15px;
    opacity: 0.9;
}

.package-card:hover {
    transform: translateY(-6px) scale(1.02);
}

.package-card.active {
    outline: 2px solid #0d47a1;
}

.bottom-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 30px 0;
    flex-wrap: wrap;
    gap: 20px;
}

.quantity-group label {
    margin-right: 10px;
    font-weight: 600;
    color: #333;
}

.quantity-group input {
    width: 90px;
    padding: 8px;
    border-radius: 8px;
    border: 1px solid #ccc;
    text-align: center;
}

.payable-amount {
    font-size: 17px;
    color: #333;
}

.payable-amount strong {
    display: block;
    font-size: 22px;
    color: #0d47a1;
    margin-top: 4px;
}

.buy-btn {
    margin-top: 20px;
    padding: 12px 55px;
    border-radius: 14px;
    border: none;
    background: linear-gradient(135deg, #1e87ff4d, #042a55ff);
    color: #ffffff;
    font-size: 18px;
    font-weight: 600;
    cursor: pointer;
    box-shadow: 0 8px 25px rgba(30, 136, 255, 0.35);
    transition: all 0.3s ease;
}

.buy-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 30px rgba(30, 136, 255, 0.45);
}

.buy-btn:disabled {
    background: #b0cfff;
    cursor: not-allowed;
    box-shadow: none;
    transform: none;
    opacity: 0.8;
}


.loader-overlay {
    position: fixed;
    inset: 0;
    background: rgba(255, 255, 255, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    font-weight: 600;
    z-index: 9999;
}

   .buy-package-container {
  max-width: 600px;
  margin: 80px auto 40px;
  padding: 30px;
  border-radius: 20px;
  background: #ffffff;
  box-shadow: 0 10px 35px rgba(0, 0, 0, 0.08);
  text-align: center;
}

.buy-title {
  font-size: 20px;
  font-weight: 700;
  color: #405189;
  margin-bottom: 25px;
}

.input-group input {
  width: 100%;
  max-width: 320px;
  padding: 12px 14px;
  border-radius: 10px;
  border: 1px solid #dcdcdc;
  font-size: 15px;
}

.action-btn {
  margin-top: 15px;
  padding: 10px 22px;
  border-radius: 10px;
  background: #405189;
  color: white;
  border: none;
  cursor: pointer;
}

.balance-text {
  margin-top: 20px;
  font-size: 20px;
  font-weight: 600;
}

/* ACTION AREA */
.action-section {
  margin-top: 25px;
}

/* TRANSFER / WITHDRAW BUTTONS */
.option-buttons {
  display: flex;
  gap: 15px;
  justify-content: center;
  margin-bottom: 20px;
}

.option-buttons button {
  padding: 10px 20px;
  border-radius: 10px;
  border: 1px solid #405189;
  background: white;
  color: #405189;
  cursor: pointer;
}

.option-buttons button.active {
  background: #405189;
  color: white;
}

/* FORM BOX */
.form-box {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
}

.form-box input {
  width: 100%;
  max-width: 320px;
  padding: 12px;
  border-radius: 10px;
  border: 1px solid #dcdcdc;
}

/* CONFIRM BUTTON */
.confirm-btn {
  width: 100%;
  max-width: 320px;
  padding: 12px;
  border-radius: 10px;
  background: #405189;
  color: white;
  border: none;
  cursor: pointer;
}

.confirm-btn.danger {
  background: #e53935;
}

/* MOBILE */
@media (max-width: 480px) {
  .option-buttons {
    flex-direction: column;
  }
}

    `}
            </style>
            <Footer />
        </>
    );
}
